import React, { useContext, useEffect } from 'react';
import '../../css/qualifier.css';
import QualifierBlock from './sections/qualifierBlock';
import { getCurrentAge, getNearestAge, validateAge } from '../../utilities/timeFunctions';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { AgentContext } from '../../context/AgentContext';


function Qualifier({ handleLeadData, handleSetQualifier, setResults, profile, setProfile, possibleConditions, setPossibleConditions, from}) {
    const isFeature580Enabled = process.env.REACT_APP_FUNNEL_FEATURE_580 === 'true'

    // ===== leads popup full data =====
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);


    const leadData=[
        {name:'First',column:'borrower_first', type:'input'},
        {name:'Last',column:'borrower_last', type:'input'},
        {name:'Sex',column:'borrower_sex', type:'drop', options:[{title:'Select Sex',value:''},{title:'Male',value:'Male'},{title:'Female',value:'Female'}]},
        {name:'DOB',column:'borrower_dob', type:'input'},
        {name:'Age',column:'borrower_age', type:'input'},
        {name:"Feet (height)", column:'feet', type:'input'},
        {name:"Inches (height)", column:'inches', type:'input'},
        {name:'Weight',column:'weight', type:'input'},
        {name:'Has Insurance',column:'borrower_is_covered', type:'input'},
        {name:'Current Coverage',column:'borrower_coverage', type:'input'},
        {name:'Occupation', column:'borrower_occupation', type:'input'},
        {name:'Primary Concern',column:'concerns', type:'input'},
        {name:'Tobacco Use',column:'tobacco', type:'drop', options:[{title:'Select Tobacco Use',value:''},{title:'Non-Tobacco',value:'no'},{title:'Tobacco',value:'yes'}]},
    ]

    const coLeadData=[
        {name:'First',column:'co_borrower_first', type:'input'},
        {name:'Last',column:'co_borrower_last', type:'input'},
        {name:'DOB',column:'co_borrower_dob', type:'input'},
        {name:'Age',column:'co_borrower_age', type:'input'},
        {name:"Feet (height)", column:'co_borrower_feet', type:'input'},
        {name:"Inches (height)", column:'co_borrower_inches', type:'input'},
        {name:'Weight',column:'co_borrower_weight', type:'input'},
        {name:'Has Insurance',column:'co_borrower_is_covered', type:'input'},
        {name:'Current Coverage',column:'co_borrower_coverage', type:'input'},
        {name:'Occupation', column:'co_borrower_occupation', type:'input'},
        {name:'Tobacco Use',column:'co_borrower_tobacco', type:'input'}
    ]
    const mortgage=[
        {name:'Mortgage Value',column:'mortgage', type:'input'},
        {name:'Home Value',column:'home_value', type:'input'},
        {name:'Loan Type',column:'loan_type', type:'input'},
        {name:'Loan Term',column:'term_length', type:'input'},
        {name:'Home Payment',column:'payment', type:'input'}
    ]
    const handleSetProfile= (column, value)=>{
        setProfile(prevProfile => ({...prevProfile,[column]:value}));
    }
    // auto-calculate borrower_age whenever a valid DOB is enterd
    // only update the age when the year is a valid 4 numerical year
    // this help cut down on the amount of re-renders and calls to run VM
    // that get made
    useEffect(() => {
        // const isValidDate = (lead[0].borrower_dob !== undefined && lead[0].borrower_dob !== null) ? lead[0].borrower_dob.split('/')[2].length === 4 : false
        let isValidDate = false

        if(leadsAlldata?.borrower_dob !== undefined && leadsAlldata?.borrower_dob !== null){
            const splitDates = leadsAlldata?.borrower_dob.split('/')

            if(splitDates[2] !== undefined){
                isValidDate = splitDates[2].length === 4
            }
        }

        const date = new Date(leadsAlldata?.borrower_dob);
        let age = -1

        if(isValidDate && date instanceof Date && !isNaN(date)){
            age = isFeature580Enabled===true ? getCurrentAge(leadsAlldata?.borrower_dob) : getNearestAge(leadsAlldata?.borrower_dob)

            if(validateAge(age)){
                handleLeadData('borrower_age', age)
                handleSetProfile('borrower_age', age)
            }
        }

    },[leadsAlldata?.lead_id, leadsAlldata?.borrower_dob])

    // update to make sure that the DOB field
    // is properly formatted
    useEffect(() => {
        // check against this regex to make sure that
        // we only trigger the formating call when
        // the date isn't already in the MM/DD/YYYY format
        const reg = /^\d{2}\/\d{2}\/\d{4}$/

        if(leadsAlldata?.borrower_dob != false && !reg.test(leadsAlldata?.borrower_dob)){
            const m_dob = moment(leadsAlldata?.borrower_dob)

            if(m_dob.isValid()){
                handleLeadData('borrower_dob', m_dob.format('MM/DD/YYY'))
            }
        }
    }, [leadsAlldata?.lead_id])

    const {isB2B} = useContext(AgentContext)
    return (
        <div className="qualifierData" style={{margin: 'unset', position:'relative'}}>
            {!from && (
                <>
                    <div className={`returnToLeadCard ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>handleSetQualifier()}>Return To Lead</div>
                    <div className="title">Qualifier</div>
                </>
            )}
            <QualifierBlock possibleConditions={possibleConditions} setPossibleConditions={setPossibleConditions} profile={profile} setProfile={setProfile} setResults={setResults} setLead={handleLeadData} title="Lead Information" startOpen={true} leadMainData={leadData}/>
            <QualifierBlock possibleConditions={possibleConditions} setPossibleConditions={setPossibleConditions} profile={profile} setProfile={setProfile} setResults={setResults} setLead={handleLeadData} title="Mortgage Info" startOpen={true} leadMainData={mortgage}/>
            <QualifierBlock possibleConditions={possibleConditions} setPossibleConditions={setPossibleConditions} profile={profile} setProfile={setProfile} setResults={setResults} setLead={handleLeadData} title="Co Lead Information" startOpen={false} leadMainData={coLeadData} isCoLead={true}/>
        </div>
    );
}

export default Qualifier;